import { errorHandler } from "components/AppHeader/NotificationMessages";
import { QUERY_KEYS, notificationTypes } from "library/shared";
import moment from "moment";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";

const issueCascoPolicy = async (dataObj) => {
  const response = await api.post(`/IssueCascoPolicy`, {
    appInfo: {
      dataObj: {
        ...dataObj,
        validFrom: moment(dataObj?.validFrom).format("YYYY-MM-DD"),
      },
      resolvedProperties: {
        title: "BCR Heavy Machinery",
      },
    },
  });

  return response.data?.appInfo;
};

function useIssueCascoPolicy() {
  const queryClient = useQueryClient();

  return useMutation(issueCascoPolicy, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.vehicleList });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.offerDataItem });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.offerCopyDataItem });
    },
    onError: (error: any) => {
      errorHandler({
        label: "Error",
        type: notificationTypes.error,
        value: "Error while issue casco policy ",
        errors: error?.message,
        fieldName: "",
      });
    },
  });
}

export default useIssueCascoPolicy;
